import { NoMansLandFlagIcon } from '@shared/custom-icons';
import { SxProps, Theme, Box } from '@mui/material';
import { useMemo } from 'react';
import { SanityCountry } from '@dap/memberadmin/types';
// eslint-disable-next-line @nx/enforce-module-boundaries, import/no-extraneous-dependencies
import * as Flags from 'country-flag-icons/react/1x1';

interface Props {
  size?: string;
  country?: string;
  sx?: Omit<SxProps<Theme>, 'width' | 'height'>;
  countries?: SanityCountry[];
}

const Flag = ({ country, size = '24px', sx, countries = [] }: Props) => {
  const sanityCountry = useMemo(() => {
    if (!country || !countries.length) return null;
    return countries.find((c) => c.code.toUpperCase() === country.toUpperCase()) || null;
  }, [country, countries]);

  const countryCode = sanityCountry?.code;

  if (countryCode && typeof countryCode === 'string' && countryCode.length === 2) {
    const FlagComponent = (
      Flags as Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>
    )[countryCode.toUpperCase()];
    if (FlagComponent) {
      return (
        <Box
          data-test-id={countryCode?.toLowerCase()}
          sx={{
            width: size,
            height: size,
            borderRadius: '100%',
            overflow: 'hidden',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid transparent',
            ...sx,
          }}
        >
          <FlagComponent style={{ width: '100%', height: '100%' }} />
        </Box>
      );
    }
  }

  return (
    <NoMansLandFlagIcon
      data-test-id="noMansFlag"
      sx={{
        height: size,
        width: size,
        borderRadius: '100%',
        ...sx,
      }}
    />
  );
};

export default Flag;
